import script from "./sidebar-section.vue?vue&type=script&lang=ts&setup=true"
export * from "./sidebar-section.vue?vue&type=script&lang=ts&setup=true"

import "./sidebar-section.vue?vue&type=style&index=0&id=d11f5920&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d11f5920"]])

export default __exports__